import { createFileRoute, redirect, type SearchSchemaInput } from '@tanstack/react-router';

// The search engine's old testing page (19–26 Oct 2026). Find creators runs on the engine now, with the debug view
// for Dreamwell people, so its address only forwards there, an open search included.
export const Route = createFileRoute('/_authed/search-engine')({
  validateSearch: (search: { search?: unknown } & SearchSchemaInput): { search?: number } => {
    const id = typeof search.search === 'number' ? search.search : typeof search.search === 'string' ? Number(search.search) : Number.NaN;
    return Number.isInteger(id) && id > 0 ? { search: id } : {};
  },
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/find-creators', search: search.search ? { search: search.search } : {}, replace: true });
  },
});
